import { Component } from '@angular/core';

/**
 * Puzzle hexagonal del hero (motivo de marca), variante v2.
 * Las 4 piezas son los paths reales del logo vectorial original
 * (`todosector.svg` → isotipo), recoloreadas en tonos teal (--hex1..4):
 * 3 piezas fijas + la superior-derecha despegada con su hueco punteado, que
 * encaja (snap) al hacer hover. Como la pieza y el hueco comparten el mismo
 * path, el encaje es pixel-perfect. En táctil / prefers-reduced-motion se
 * muestra ya encajada. Sin movimiento en reposo.
 */
@Component({
  selector: 'app-hero-puzzle',
  standalone: true,
  templateUrl: './hero-puzzle.component.html',
  styleUrl: './hero-puzzle.component.scss',
})
export class HeroPuzzleComponent {}
